import { Box, Button, Grid, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import Breadcrumb from '../component/Breadcrumb';

const AccessDenied = () => {
  return (
    <>
        <Breadcrumb title="Access Denied">
            <Typography variant="subtitle2" color="#8C8C8C" className="link-breadcrumb">Home</Typography>
            <Typography variant="subtitle2" className="link-breadcrumb">Permission </Typography>
        </Breadcrumb>
        <Box component="section">
            <Grid className="contentBox">
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={3}>
                    <Typography sx={{pt:12}} variant="h1">Access Denied!</Typography>
                    <Typography variant="h4">You do not have permission to view this page.</Typography>
                    <Typography variant="span">Please click on the below button to navigate to the dashboard page.</Typography>
                    <Button component={Link} to="/" variant="contained">Dashboard</Button>
                </Box>
            </Grid>
        </Box>
    </>
  )
}

export default AccessDenied